module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.57049in",
      "height": "2.97697in"
    },
    attrs: {
      "alt": "",
      "src": "media/file0.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("C:\\Users\\Admin\\Contacts\\Desktop\\IMG_1037.jpg")])]), _c('br'), _vm._v(" "), _c('p', [_vm._v("Born in Bangladesh, Shukdeb Sen moved to Calcutta (now Kolkata), India. He then immigrated to U.S.A. and has spent over a thirty-year career in teaching, research, and mentoring undergraduate students at various colleges and universities in South. "), _c('em', [_vm._v("If Life Was a Dream")]), _vm._v(" is his first poetry book. He has published a non-fiction book titled, "), _c('em', [_vm._v("Black Education in White America.")]), _vm._v(" He authored over thirty research articles in scientific journals and he currently lives in Florida, U.S.A.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bbe9e50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0